import React from 'react';

const CorporateSecretaryship = () => {
  return (
    <div>
      CorporateSecretaryship
      CorporateSecretaryship
    </div>
  );
}

export default CorporateSecretaryship;
